export default function NotFound() {
  return (
    <div className="container py-16">
      <div className="max-w-lg rounded border p-6 bg-white dark:bg-gray-900">
        <div className="text-3xl font-bold mb-2">404</div>
        <div className="text-lg mb-4">We couldn’t find that page.</div>
        <a className="underline" href="/">Return to home</a>
      </div>
    </div>
  )
}
